import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPhysiciansListAPI,deletePhysiciansAPI,updatePhysiciansAPI,addPhysiciansAPI,fetchPhysiciansDetailsAPI } from '../apis/physician';


// Your getPhysiciansList async thunk
export const getPhysiciansList = createAsyncThunk(
    'members/getPhysiciansList',
    async (data, { rejectWithValue }) => {
        try {
            const res = await getPhysiciansListAPI(data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);


export const fetchPhysicianDetails = createAsyncThunk(
    'members/fetchPhysicianDetails',
    async (roleId, { rejectWithValue }) => {
        try {
            const res = await fetchPhysiciansDetailsAPI(roleId)
            return res
        } catch (error) {
             
            return rejectWithValue(error?.response?.data)
        }
    }
)

export const addPhysician = createAsyncThunk(
    'members/addPhysician',
    async (data, { rejectWithValue }) => {
        try {
            const res = await addPhysiciansAPI(data)
            return res
        } catch (error) {
             
            return rejectWithValue(error?.response?.data)
        }
    }
)


export const updatePhysician = createAsyncThunk(
    'members/updatePhysician',
    async ({ data, adminId }, { rejectWithValue }) => {
        try {
            const res = await updatePhysiciansAPI(data, adminId)
            return res
        } catch (error) {
             
            return rejectWithValue(error?.response?.data)
        }
    }
)

export const deletePhysician = createAsyncThunk(
    'members/deletePhysician',
    async (adminId, { rejectWithValue }) => {
        try {
            const res = await deletePhysiciansAPI(adminId)
            return res
        } catch (error) {
             
            return rejectWithValue(error?.response?.data)
        }
    }
)




// Create a slice for orders
const physicianSlice = createSlice({
    name: 'physician',
    initialState: {
        physicianList: [],
        isLoading: false, // Flag to track loading status
        error: null,
        physicianDetail:{},
        isUpdatingStatus: false
    },
    reducers: {
        // You can define additional reducers here if needed
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPhysiciansList.pending, (state) => {
                state.isLoading = true; // Set isLoading to true when fetching starts
                state.error = null; // Reset error when starting a new fetch
                state.physicianDetail = {}
            })
            .addCase(getPhysiciansList.fulfilled, (state, action) => {
                state.isLoading = false; // Set isLoading to false when fetching completes
                state.physicianList = action.payload; // Update orders with the fetched data
            })
            .addCase(getPhysiciansList.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload; // Update error in case of failure
            });

        builder.addCase(fetchPhysicianDetails.fulfilled, (state, action) => {
            state.isLoading = false;
            state.physicianDetail = action.payload.data; // Update state with the received details
            state.error = null;
        });

        // Extra reducer for the rejected action of fetchPhysicianDetails
        builder.addCase(fetchPhysicianDetails.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload; // Update state with the error message
        });

        // Extra reducer for the pending action of fetchPhysicianDetails
        builder.addCase(fetchPhysicianDetails.pending, (state) => {
            state.isLoading = true;
        });

        builder
            .addCase(addPhysician.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })

        builder.addCase(addPhysician.fulfilled, (state, action) => {
            state.isLoading = false;
            state.addedPhysician = action.payload; // Update state with the added member data
            state.error = null;
        });

        // Extra reducer for the rejected action of addPhysician
        builder.addCase(addPhysician.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload; // Update state with the error message
        });

        builder
            .addCase(updatePhysician.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updatePhysician.fulfilled, (state, action) => {
                state.isLoading = false;
                // You can update your state with the data received from the API if needed
            })
            .addCase(updatePhysician.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload; // The error message returned from the API
            });


        builder
            .addCase(deletePhysician.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(deletePhysician.fulfilled, (state, action) => {
                state.isLoading = false;
                // You can update your state with the data received from the API if needed
            })
            .addCase(deletePhysician.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload; // The error message returned from the API
            });


    },
});

export const { /* any additional actions */ } = physicianSlice.actions;
export default physicianSlice.reducer;
